import request from '@/utils/request'
// 搜索标题列表
export function SeacrhList(data) {
    return request({
        url:'/netbar/api/knowledge_base/v1/list',
        method:'post',
        data
    })
}
// 搜索列表详情
export function SeacrhListDetails(data) {
    return request({
        url:'/netbar/api/knowledge_base/v1/detail',
        method:'post',
        data
    })
}